module.exports = ".link-delete-style {\r\n    color : red;\r\n    cursor : pointer;        \r\n}"